package gr.tech.meetinggenie.sections

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import gr.tech.meetinggenie.models.meeting.ProjectUpdateDTO
import gr.tech.meetinggenie.styles.*
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.*

@Composable
fun ProjectUpdatesTableInput(
    projectUpdates: List<ProjectUpdateDTO>,
    onUpdate: (List<ProjectUpdateDTO>) -> Unit,
) {
    DraggableDataTable(
        rowCount      = projectUpdates.size,
        onMove        = { from, to -> onUpdate(projectUpdates.toMutableList().also { it.add(to, it.removeAt(from)) }) },
        onDelete      = { index   -> onUpdate(projectUpdates.toMutableList().also { it.removeAt(index) }) },
        addButtonText = "Add Update",
        onAdd         = { onUpdate(projectUpdates + ProjectUpdateDTO()) },
        headers = {
            Th(DataEntryCellTextStyle.toModifier().padding(4.px).minWidth(160.px).toAttrs()) { Text("Account / Project Name") }
            Th(DataEntryCellTextStyle.toModifier().padding(4.px).minWidth(320.px).toAttrs()) {
                Text("What changed since last week?")
                Span(DataEntryCellTextStyle.toModifier().color(com.varabyte.kobweb.compose.ui.graphics.Colors.Gray).toAttrs()) {
                    Text(" — Skip if no change")
                }
            }
        },
        rowCells = { index ->
            val item = projectUpdates[index]

            // Account / Project Name
            Td(DataEntryCellStyle.toModifier().minWidth(160.px).padding(0.px).toAttrs()) {
                autoResizeTextArea(
                    value   = item.accountName,
                    onInput = { v -> onUpdate(projectUpdates.toMutableList().also { it[index] = it[index].copy(accountName = v) }) }
                )
            }

            // What changed — paragraph textarea
            Td(DataEntryCellStyle.toModifier().minWidth(320.px).padding(0.px).toAttrs()) {
                autoResizeTextArea(
                    value   = item.whatChanged,
                    onInput = { v -> onUpdate(projectUpdates.toMutableList().also { it[index] = it[index].copy(whatChanged = v) }) }
                )
            }
        }
    )
}
